export default __webpack_public_path__ + "5c6b499.png";